import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MasterLayout from '../../masterLayout/MasterLayout';

const CambiarContrasena = () => {
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);
  const [form, setForm] = useState({
    contra_actual: '',
    contra_nueva: '',
    contra_confirmar: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async (e) => {
    e.preventDefault();

    if (!form.contra_actual.trim()) {
      window.notie.alert({ type: 'warning', text: 'Por favor ingresa tu contraseña actual.' });
      return;
    }
    if (!form.contra_nueva.trim()) {
      window.notie.alert({ type: 'warning', text: 'Por favor ingresa tu nueva contraseña.' });
      return;
    }
    if (form.contra_nueva.length < 6) {
      window.notie.alert({ type: 'warning', text: 'La nueva contraseña debe tener al menos 6 caracteres.' });
      return;
    }
    if (form.contra_nueva !== form.contra_confirmar) {
      window.notie.alert({ type: 'warning', text: 'Las nuevas contraseñas no coinciden.' });
      return;
    }

    setIsSaving(true);
    try {
      const response = await fetch('/p_cambiar_contra', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          contra_actual: form.contra_actual,
          contra_nueva: form.contra_nueva
        })
      });

      const data = await response.json();
      if (data.status === 1) {
        window.notie.alert({ type: 'success', text: 'Contraseña cambiada con éxito.' });
        setForm({
          contra_actual: '',
          contra_nueva: '',
          contra_confirmar: ''
        });
      } else {
        window.notie.alert({ type: 'error', text: data.message || 'Error al cambiar la contraseña.' });
      }
    } catch (error) {
      console.error('Error al cambiar contraseña:', error);
      window.notie.alert({ type: 'error', text: 'Error de red o del servidor.' });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <MasterLayout>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <div>
          <h6 className="text-lg mb-1">Perfil</h6>
          <p className="text-sm text-secondary-light mb-0">Cambiar Contraseña</p>
        </div>
      </div>

      <div className="card h-100 p-0 radius-12 overflow-hidden">
        <div className="card-body p-40">
          <div className="row justify-content-center">
            <div className="col-xxl-6 col-xl-8 col-lg-10 col-sm-12">
              <form onSubmit={handleSave}>
                <div className="mb-20">
                  <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                    Contraseña Actual <span className="text-danger-600">*</span>
                  </label>
                  <input
                    type="password"
                    name="contra_actual"
                    value={form.contra_actual}
                    onChange={handleChange}
                    className="form-control radius-8"
                    placeholder="Ingresa tu contraseña actual"
                    required
                  />
                </div>

                <div className="mb-20">
                  <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                    Nueva Contraseña <span className="text-danger-600">*</span>
                  </label>
                  <input
                    type="password"
                    name="contra_nueva"
                    value={form.contra_nueva}
                    onChange={handleChange}
                    className="form-control radius-8"
                    placeholder="Ingresa tu nueva contraseña (mínimo 6 caracteres)"
                    required
                  />
                </div>

                <div className="mb-20">
                  <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                    Confirmar Nueva Contraseña <span className="text-danger-600">*</span>
                  </label>
                  <input
                    type="password"
                    name="contra_confirmar"
                    value={form.contra_confirmar}
                    onChange={handleChange}
                    className="form-control radius-8"
                    placeholder="Confirma tu nueva contraseña"
                    required
                  />
                </div>

                <div className="d-flex align-items-center justify-content-between gap-3 mt-24">
                  <button
                    type="button"
                    onClick={() => navigate(-1)}
                    className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                  >
                    Cancelar
                  </button>
                  <button
                    type="submit"
                    disabled={isSaving}
                    className="btn btn-primary border border-primary-600 text-md px-24 py-12 radius-8 d-flex align-items-center gap-2"
                  >
                    {isSaving ? 'Actualizando...' : 'Actualizar'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </MasterLayout>
  );
};

export default CambiarContrasena;
